const REQUIRED = [
  'VITE_SUPABASE_URL',
  'VITE_SUPABASE_ANON_KEY',
] as const;

const WARN_IF_MISSING = [
  'VITE_SENTRY_DSN',
  'VITE_EBAY_CLIENT_ID',
] as const;

/**
 * Throws if any of the required Vite env vars are missing or empty.
 * Should be called once at app startup; the message names every
 * missing var and points at .env.example.
 */
export function validateEnv(): void {
  const missing = (REQUIRED as readonly string[]).filter(
    (key) => !import.meta.env[key],
  );
  if (missing.length === 0) {
    warnMissing();
    return;
  }

  const list = missing.map((k) => `  • ${k}`).join('\n');
  throw new Error(
    `Missing required environment variables:\n${list}\n\n` +
      `Copy .env.example to .env and fill in the values.\n` +
      `Supabase keys are in your project dashboard → Settings → API.`,
  );
}

function warnMissing(): void {
  const missing = (WARN_IF_MISSING as readonly string[]).filter(
    (key) => !import.meta.env[key],
  );
  for (const key of missing) {
    console.warn(`[env] ${key} is not set — some features will be unavailable (error reporting, eBay OAuth)`);
  }
}
